import React, { useState, useEffect, useRef } from 'react';

const NAV_ITEMS = [
  { href: '#home',      icon: 'fa-house',            label: 'Home'       },
  { href: '#aboutus',   icon: 'fa-circle-info',      label: 'About Us'   },
  { href: '#services',  icon: 'fa-briefcase',        label: 'Services'   },
  { href: '#projects',  icon: 'fa-diagram-project',  label: 'Projects'   },
  { href: '#contactus', icon: 'fa-envelope',         label: 'Contact Us' },
];

const SidebarMenu = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [activeLink, setActiveLink] = useState('#home');
  const sidebarRef = useRef(null);

  const toggleSidebar = (e) => {
    e && e.stopPropagation?.();
    setIsExpanded(prev => !prev);
  };

  const handleLinkClick = (link) => {
    setActiveLink(link);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!sidebarRef.current) return;
      if (isExpanded && !sidebarRef.current.contains(event.target)) {
        setIsExpanded(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isExpanded]);

  return (
    <>
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.7.2/css/all.min.css"
        crossOrigin="anonymous"
        referrerPolicy="no-referrer"
      />

      <style>{`
        * { margin: 0; padding: 0; box-sizing: border-box; }
        html, body { height: 100%; }

        /* ── SIDEBAR ── */
        .sb {
          position: fixed;
          top: 0; left: 0; bottom: 0;
          width: 76px;
          padding: 16px 10px;
          background: #fff;
          border-right: 1px solid #ede8df;
          box-shadow: 2px 0 16px rgba(0,0,0,0.06);
          z-index: 1000;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 0;
          transition: width 0.28s cubic-bezier(.4,0,.2,1);
          overflow: hidden;
          font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
        }
        .sb.open { width: 230px; align-items: flex-start; }

        /* ── TOGGLE BUTTON ── */
       
        .sb.open .sb-toggle i { transform: rotate(180deg); }

        /* ── LOGO ── */
        .sb-logo {
          display: flex;
          align-items: center;
          gap: 10px;
          margin: 28px 0 24px;
          cursor: pointer;
          padding: 0 4px;
          white-space: nowrap;
          width: 100%;
          text-decoration: none;
        }
        .sb-logo-icon {
          width: 44px;
          height: 44px;
          border-radius: 10px;
          background: #101035;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
        .sb-logo-icon i { color: #f4c58c; font-size: 22px; }
        .sb-logo-text {
          font-size: 17px;
          font-weight: 700;
          color: #101035;
          letter-spacing: -0.01em;
          opacity: 0;
          transform: translateX(-6px);
          transition: opacity 0.2s, transform 0.2s;
          pointer-events: none;
          white-space: nowrap;
        }
        .sb.open .sb-logo-text {
          opacity: 1;
          transform: translateX(0);
        }

        /* ── DIVIDER ── */
        .sb-divider {
          width: 100%;
          height: 1px;
          background: #ede8df;
          margin-bottom: 12px;
          flex-shrink: 0;
        }

        /* ── NAV MENU ── */
        ul.sb-menu {
          list-style: none;
          width: 100%;
          display: flex;
          flex-direction: column;
          gap: 4px;
          flex: 1;
        }

        .sb-menu a {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 12px 10px;
          border-radius: 10px;
          text-decoration: none;
          color: #555;
          transition: background 0.15s, color 0.15s;
          white-space: nowrap;
          width: 100%;
          position: relative;
        }
        .sb-menu a:hover {
          background: #fdf8f2;
          color: #101035;
        }
        .sb-menu a.active {
          background: #101035;
          color: #f4c58c;
        }
        .sb-menu a.active i { color: #f4c58c; }

        .sb-menu a i {
          font-size: 22px;
          width: 34px;
          text-align: center;
          flex-shrink: 0;
          color: inherit;
          transition: color 0.15s;
        }
        .sb-menu a:hover i { color: #101035; }

        .sb-menu a span {
          font-size: 15px;
          font-weight: 600;
          opacity: 0;
          transform: translateX(-6px);
          transition: opacity 0.18s, transform 0.18s;
          pointer-events: none;
        }
        .sb.open .sb-menu a span {
          opacity: 1;
          transform: translateX(0);
        }

        /* Collapsed tooltip on hover */
        .sb:not(.open) .sb-menu a:hover::after {
          content: attr(data-label);
          position: absolute;
          left: 58px;
          top: 50%;
          transform: translateY(-50%);
          background: #101035;
          color: #f4c58c;
          font-size: 12px;
          font-weight: 600;
          padding: 5px 12px;
          border-radius: 8px;
          white-space: nowrap;
          pointer-events: none;
          z-index: 9999;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        }

        /* ── MOBILE BOTTOM BAR ── */
        .sb-bottom { display: none; }

        @media (max-width: 768px) {
          .sb { display: none; }
          .sb-bottom {
            display: flex;
            position: fixed;
            bottom: 0; left: 0;
            width: 100%;
            height: 58px;
            background: #101035;
            border-top: 1px solid rgba(255,255,255,0.08);
            justify-content: space-around;
            align-items: center;
            z-index: 999;
            font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
          }
          .sb-bottom a {
            color: rgba(255,255,255,0.55);
            text-decoration: none;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            flex: 1;
            height: 100%;
            gap: 3px;
            transition: color 0.15s;
            font-size: 11px;
            font-weight: 600;
            letter-spacing: 0.03em;
          }
          .sb-bottom a i { font-size: 22px; }
          .sb-bottom a.active { color: #f4c58c; }
          .sb-bottom a:hover  { color: #f4c58c; }
        }
      `}</style>

      {/* ── SIDEBAR ── */}
      <nav
        ref={sidebarRef}
        className={`sb ${isExpanded ? 'open' : ''}`}
        aria-expanded={isExpanded}
      >


        {/* Logo */}
        <div className="sb-logo" onClick={toggleSidebar} role="button" tabIndex={0}>
          <div className="sb-logo-icon">
            <i className="fa-solid fa-web-awesome" aria-hidden="true" />
          </div>
          <span className="sb-logo-text">Fair &amp; Fiery</span>
        </div>

        <div className="sb-divider" />

        {/* Nav */}
        <ul className="sb-menu" role="menu" style={{paddingLeft: '0rem'}}>
          {NAV_ITEMS.map(({ href, icon, label }) => (
            <li key={href}>
              <a
                href={href}
                data-label={label}
                className={activeLink === href ? 'active' : ''}
                onClick={() => handleLinkClick(href)}
              >
                <i className={`fa-solid ${icon}`} aria-hidden="true" />
                <span>{label}</span>
              </a>
            </li>
          ))}
        </ul>
      </nav>

      {/* ── MOBILE BOTTOM BAR ── */}
      <div className="sb-bottom">
        {NAV_ITEMS.map(({ href, icon, label }) => (
          <a
            key={href}
            href={href}
            className={activeLink === href ? 'active' : ''}
            onClick={() => setActiveLink(href)}
          >
            <i className={`fa-solid ${icon}`} aria-hidden="true" />
            <span>{label.replace(' Us', '')}</span>
          </a>
        ))}
      </div>
    </>
  );
};

export default SidebarMenu;